
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { User } from '../../lib/models/User'

import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { parsePhoneNumber } from 'libphonenumber-js'

import BacButton from '../BacButton.vue'
import BacAlert from '../BacAlert.vue'

@Component({
  components: {
    VuePhoneNumberInput,
    BacButton,
    BacAlert
  }
})
export default class RallyRegisterPhoneNumber extends Vue {
  @Prop({ required: true }) user!: User

  mode = 'show'

  phone: any = {};
  phoneNumberInputModel = ''; // needs to exist even when not used, does not work without a v-model even though you have to use the update event anyway, made a github issue about it: https://github.com/LouisMazel/vue-phone-number-input/issues/163
  defaultCountry = 'AT';

  get userPhoneNumber () {
    return this.user.telephone
      ? (parsePhoneNumber as any)(this.user.telephone, {
        defaultCountry: 'AT'
      })
      : ''
  }

  mounted () {
    this.onPhoneChanged()
    this.onUserChange()
  }

  @Watch('phone')
  public onPhoneChanged () {
    this.user.telephone = this.phone.formatInternational
  }

  @Watch('user')
  public onUserChange () {
    this.mode = this.user.telephone ? 'show' : 'edit'
    this.phoneNumberInputModel = this.userPhoneNumber.nationalNumber;
    (this.defaultCountry as any) = this.userPhoneNumber.country
  }
}
